import { render } from "./NavbarTop.vue?vue&type=template&id=4704c97a"
import script from "./NavbarTop.vue?vue&type=script&lang=js"
export * from "./NavbarTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__